export default __webpack_public_path__ + "static/media/afterpay.inline.48626a4e.svg";